"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addContentFields = exports.extractSearchable = exports.getRoleFilter = void 0;
const contentful_1 = require("../contentful");
const getRoleFilter = (roles) => {
    // using scripted filters from ES DSL to apply the given rules above.
    const roleQueryScript = roles.map(role => `doc['roles'].values.contains('${role}')`);
    const startQuery = 'doc[\'roles\'].empty';
    return {
        script: {
            script: {
                source: [startQuery, roleQueryScript.join(' || ')].filter(Boolean).join(' || '),
            },
        },
    };
};
exports.getRoleFilter = getRoleFilter;
const extractSearchable = (text) => {
    if (!text || !text.length) {
        return text;
    }
    return text.toLowerCase().replace(/[^0-9a-z]/gi, '');
};
exports.extractSearchable = extractSearchable;
const addContentFields = (entry, contentType) => {
    var _a, _b, _c;
    switch (contentType) {
        case contentful_1.ContentfulHelpers.CONTENT_TYPES.TOPIC:
            entry.fields.title = entry.fields.name;
            if (entry.fields.level === 'level1' && ((_c = (_b = (_a = entry.fields.parent) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.fields) === null || _c === void 0 ? void 0 : _c.slug)) {
                entry.fields.slug = `${entry.fields.parent[0].fields.slug}/${entry.fields.slug}`;
            }
            entry.fields.contentCategory = {
                fields: {
                    name: 'Topic',
                    slug: 'topic',
                },
            };
            entry.fields.dateCreated = entry.sys.createdAt;
            break;
    }
    return entry;
};
exports.addContentFields = addContentFields;
//# sourceMappingURL=index.js.map